<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="300px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3>{{ showTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2"
        ><h5>{{ showText }}</h5></v-card-text
      >
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Ne"
          @click.native.stop="closeModal()"
          color="secondary"
        />
        <el-button title="Taip" @click.native="confirm()" color="primary" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import errorNotifications from '@/mixins/errorNotifications'

export default {
  name: 'ModalDataLost',
  mixins: [errorNotifications],
  props: {
    value: Boolean,
    title: String,
    text: String,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {}
  },
  computed: {
    showTitle() {
      return this.$t(this.title)
    },

    showText() {
      return this.$t(this.text)
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },

    cancel() {
      this.closeModal()
    },

    confirm() {
      this.$emit('confirmNext')
    },
  },
}
</script>
<style lang="scss" scoped></style>
